import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListingChatsRoutingModule } from './listing-chats-routing.module';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';
import { Angulartics2Module } from 'angulartics2';
import { AllChatsPageComponent } from './components/all-chats-page/all-chats-page.component';
import { ListingChatsPageComponent } from './components/listing-chats/listing-chats-page.component';
import { SellerListingChatPageComponent } from './components/seller-listing-chat-page/seller-listing-chat-page.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '../shared/shared.module';
import { CompactListingButtonsComponent } from './components/compact-listing-buttons/compact-listing-buttons.component';
import { CompactListingImageComponent } from './components/compact-listing-image/compact-listing-image.component';
import { CompactListingDescriptionComponent } from './components/compact-listing-description/compact-listing-description.component';
import { ChatComponent } from './components/chat/chat.component';
import { MatBadgeModule } from '@angular/material/badge';
import { ShareButtonModule } from '../shared/share-button/share-button.module';
import { ScanGMailButtonModule } from '../shared/scan-gmail-button/scan-gmail-button.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
	  AllChatsPageComponent,
	  ListingChatsPageComponent,
	  SellerListingChatPageComponent,
	  CompactListingButtonsComponent,
	  CompactListingImageComponent,
	  CompactListingDescriptionComponent,
	  ChatComponent
  ],
  imports: [
    CommonModule,
    ListingChatsRoutingModule,
    MatButtonModule,
    MatIconModule,
    Angulartics2Module,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatDividerModule,
    MatMenuModule,
    MatBadgeModule,
    SharedModule,
    ShareButtonModule,
    ScanGMailButtonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ChatComponent
  ],
})
export class ListingChatsModule { }
